import './ThemeCoverTransition.css';

const EXPAND_MS = 680;
const FADE_MS = 420;

let running = false;

export function isThemeCoverRunning() {
  return running;
}

function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function originFromEvent(event) {
  const el = event && (event.currentTarget || event.target);
  if (el && typeof el.getBoundingClientRect === 'function') {
    const r = el.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  return {
    x: typeof window !== 'undefined' ? window.innerWidth - 48 : 0,
    y: 48,
  };
}

function coverRadius(x, y) {
  const w = window.innerWidth;
  const h = window.innerHeight;
  return Math.hypot(Math.max(x, w - x), Math.max(y, h - y));
}

/**
 * Cobre a tela com um círculo do tema destino, aplica o tema e some.
 * @param {{ toDark: boolean, event?: Event, apply: () => void }} opts
 */
export function playThemeCoverTransition({ toDark, event, apply }) {
  if (typeof document === 'undefined' || prefersReducedMotion() || running) {
    apply();
    return;
  }

  running = true;
  const { x, y } = originFromEvent(event);
  const radius = coverRadius(x, y);

  const overlay = document.createElement('div');
  overlay.className = `theme-cover-overlay${toDark ? ' is-dark' : ' is-light'}`;
  overlay.setAttribute('aria-hidden', 'true');

  const circle = document.createElement('div');
  circle.className = 'theme-cover-circle';
  circle.style.left = `${x}px`;
  circle.style.top = `${y}px`;
  circle.style.width = `${radius * 2}px`;
  circle.style.height = `${radius * 2}px`;
  overlay.appendChild(circle);
  document.body.appendChild(overlay);

  requestAnimationFrame(() => {
    overlay.classList.add('is-expanding');
  });

  window.setTimeout(() => {
    try {
      apply();
    } catch (_) { /* ignore */ }
    overlay.classList.add('is-fading');
    window.setTimeout(() => {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      running = false;
    }, FADE_MS);
  }, EXPAND_MS);
}
